export default "__VITE_ASSET__8cb38abb__"